import type { CommonResponse } from '@models/common';
import type { ApiError } from '@utils/customErrors';
import {
  ApiFailedError,
  MyHeartBrandApiError,
  MyHeartCollectionApiError,
  MyHeartContentsApiError,
  MyHeartProductApiError,
  NetworkOfflineError,
  ShortformApiError,
  StyleclipNoNContent,
} from '@utils/customErrors';
import { getDeviceName } from '@wconcept/wconcept-common/utils/deviceUtil';

const isSsr = (): boolean => typeof window === 'undefined';

export function throwClientFailError(data: CommonResponse) {
  if (data?.errorCode === 30203 || data?.errorCode === 30204) {
    throw new MyHeartCollectionApiError(data.message, data.errorCode);
  }
  if (data?.errorCode === 30104) {
    throw new MyHeartProductApiError(data.message, data.errorCode);
  }
  if (data?.errorCode === 30105) {
    throw new MyHeartBrandApiError(data.message, data.errorCode);
  }
  if (data?.errorCode === 30106) {
    throw new MyHeartContentsApiError(data.message, data.errorCode);
  }
  if (data?.errorCode === 21103) {
    throw new StyleclipNoNContent();
  }
  if (data.errorCode === 20015) {
    throw new ShortformApiError();
  }
  throw new ApiFailedError(data.message, data.errorCode as number);
}

export function handleClientApiError<IResponseData>(apiError: ApiError) {
  if (!isSsr()) {
    if (apiError.alertType === 'confirm' && apiError.redirectUrl) {
      const isConfirmed = window.confirm(apiError.message);
      if (isConfirmed) {
        window.location.href = apiError.redirectUrl;
      }
      return {} as IResponseData;
    }
    if (apiError.message && apiError.alertType === 'alert') {
      window.alert(apiError.message);
    }
    if (apiError.isHistoryBack) {
      const device = getDeviceName(window.navigator.userAgent);
      if (device === 'Mobile' || device === 'PC') {
        const defaultUrl = `${process.env.NEXT_PUBLIC_WCONCEPT_DISPLAY_WEB}/rn/women`;
        if (
          window.history.length > 1 &&
          document.referrer &&
          document.referrer.includes('wconcept')
        ) {
          window.history.back();
        } else {
          window.location.href = defaultUrl;
        }
      } else {
        document.location.href = 'wconceptkr://webViewBack';
      }
    }
    if (apiError.redirectUrl) {
      window.location.href = apiError.redirectUrl;
    }
  }

  if (!isSsr() && !window.navigator.onLine) {
    throw new NetworkOfflineError();
  }

  throw apiError.status
    ? apiError
    : new ApiFailedError(apiError.message, apiError.errorCode ?? 0);
}
